import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const GoogleSheetsIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <mask
      id="mask0_24530_73510"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_24530_73510)">
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L13.9741 3.37693L11.7664 0.286133Z"
        fill="#0F9D58"
      />
    </g>
    <mask
      id="mask1_24530_73510"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_24530_73510)">
      <path
        d="M6.46777 9.7793V16.1817H13.5325V9.7793H6.46777ZM9.55857 15.2986H7.35086V14.1947H9.55857V15.2986ZM9.55857 13.5324H7.35086V12.4285H9.55857V13.5324ZM9.55857 11.7662H7.35086V10.6624H9.55857V11.7662ZM12.6494 15.2986H10.4417V14.1947H12.6494V15.2986ZM12.6494 13.5324H10.4417V12.4285H12.6494V13.5324ZM12.6494 11.7662H10.4417V10.6624H12.6494V11.7662Z"
        fill="#F1F1F1"
      />
    </g>
    <mask
      id="mask2_24530_73510"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_24530_73510)">
      <path
        d="M12.1538 5.19727L17.0649 10.1072V5.58472L12.1538 5.19727Z"
        fill="url(#paint0_linear_24530_73510)"
      />
    </g>
    <mask
      id="mask3_24530_73510"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_24530_73510)">
      <path
        d="M11.7666 0.286133V4.26001C11.7666 4.99187 12.3594 5.58464 13.0912 5.58464H17.0651L11.7666 0.286133Z"
        fill="#87CEAC"
      />
    </g>
    <mask
      id="mask4_24530_73510"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_24530_73510)">
      <path
        d="M4.26017 0.286133C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V1.72115C2.93555 0.9926 3.53163 0.396518 4.26017 0.396518H11.7664V0.286133H4.26017Z"
        fill="white"
        fillOpacity="0.2"
      />
    </g>
    <mask
      id="mask5_24530_73510"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_24530_73510)">
      <path
        d="M15.7403 19.6037H4.26017C3.53163 19.6037 2.93555 19.0076 2.93555 18.2791V18.3894C2.93555 19.118 3.53163 19.7141 4.26017 19.7141H15.7403C16.4688 19.7141 17.0649 19.118 17.0649 18.3894V18.2791C17.0649 19.0076 16.4688 19.6037 15.7403 19.6037Z"
        fill="#263238"
        fillOpacity="0.2"
      />
    </g>
    <mask
      id="mask6_24530_73510"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_24530_73510)">
      <path
        d="M13.0912 5.58464C12.3594 5.58464 11.7666 4.99187 11.7666 4.26001V4.3704C11.7666 5.10225 12.3594 5.69502 13.0912 5.69502H17.0651V5.58464H13.0912Z"
        fill="#263238"
        fillOpacity="0.1"
      />
    </g>
    <path
      d="M11.7664 0.286133H4.26017C3.53163 0.286133 2.93555 0.882215 2.93555 1.61076V18.3894C2.93555 19.1179 3.53163 19.714 4.26017 19.714H15.7403C16.4688 19.714 17.0649 19.1179 17.0649 18.3894V5.58464L11.7664 0.286133Z"
      fill="url(#paint1_radial_24530_73510)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_24530_73510"
        x1="14.6096"
        y1="5.61884"
        x2="14.6096"
        y2="10.1079"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#263238" stopOpacity="0.2" />
        <stop offset="1" stopColor="#263238" stopOpacity="0.02" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_24530_73510"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.38317 0.672302) scale(22.7834)"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </SvgIcon>
);
